/**
 * Auto-generated by yarn cross-type:gen-typescript. Do not edit by hand.
 *
 * @source dashboard/lib/shared/braze/remote_lookup/providers/sparse_segment_remote_lookup_provider.rb
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/sparse_segment_remote_lookup_provider.rb) */
export const filtersTypeSchema = z.strictObject({
  exclude_contains_segment_membership: z.boolean().nullable().optional(),
  only_user_defined: z.boolean().nullable().optional(),
});

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/sparse_segment_remote_lookup_provider.rb) */
export const filtersTypeOutputSchema = z.object({
  exclude_contains_segment_membership: z.boolean(),
  only_user_defined: z.boolean(),
});
